/**
 * Extract the `uuid` from route parameters to use as retry variables across routes
 * (e.g. `PropertyShowRoute`, `TradeListRoute`).
 * The returned object is passed to `useQueryLoader` with a `network-only` fetch policy,
 * enabling routes to trigger a fresh network fetch when recovering from errors via an
 * error boundary retry handler.
 * @param {object} props - Route props provided by found-relay.
 * @param {object} props.match - The matched route object.
 * @param {object} props.match.params - URL parameters extracted from the matched route.
 * @param {string} props.match.params.uuid - The UUID from the route path
 * (e.g. `/properties/:uuid`).
 * @returns {{uuid: string}|null} An object containing the route `uuid` suitable for passing
 *   to `useQueryLoader`, or `null` if the `uuid` parameter is missing.
 */
const getRouteUuidRetryVariables = (props) => {
  const routeUuid = props?.match?.params?.uuid;

  if (!routeUuid) {
    return null;
  }

  return {
    uuid: routeUuid,
  };
};

export default getRouteUuidRetryVariables;
